import { create } from 'zustand';

/**
 * reportDialogStore — 「回報問題」對話框的開關(R249 Step 1)
 * =============================================================================
 *
 * 三個入口散在不同層(側邊欄帳號選單 / 錯誤 toast 的 action / 未來的其他位置),
 * 對話框只掛一份在 [providers](../app/providers.tsx) —— 中間需要一個不看 React tree
 * 位置的開關,所以用 store 而不是 prop 往下傳。
 *
 * ⚠️ **刻意不 persist**:沒有 `persist` middleware = 不碰 `localStorage` = 不必進
 * [clientStorage](./clientStorage.ts) 鑰匙總表、登出不用清。對話框開著時重新整理應該
 * 回到乾淨狀態 —— 把「有個對話框開著」存起來只會製造「一進站就跳回報視窗」的怪行為。
 *
 * ⚠️ **[AppErrorBoundary](../app/AppErrorBoundary.tsx) 不用這支**:白畫面時 React tree
 * 已被卸載,掛在 Providers 內的那份 dialog 根本不會 render。那條路徑由 boundary 自己
 * 的 state 控一份 —— 出錯時能少依賴一層就少一層。
 */

import type { ReportCategory } from '@/lib/diagnostics/diagnosticsReport';

export interface ReportDialogState {
  open: boolean;
  /** 由入口預填的分類(錯誤 toast 帶 `ui_bug`);使用者仍可改。 */
  initialCategory: ReportCategory | null;
  openReportDialog: (initialCategory?: ReportCategory | null) => void;
  closeReportDialog: () => void;
}

export const useReportDialogStore = create<ReportDialogState>()((set) => ({
  open: false,
  initialCategory: null,
  openReportDialog: (initialCategory = null) => set({ open: true, initialCategory }),
  closeReportDialog: () => set({ open: false, initialCategory: null }),
}));

/** 非 React 環境(toast handler / service 層)開窗用。 */
export function openReportDialog(initialCategory?: ReportCategory | null): void {
  useReportDialogStore.getState().openReportDialog(initialCategory ?? null);
}
